import React from 'react';
import { TableSellTypeSC } from './table-sell-type.styled';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../../utils/default-lang';
import { SmallText } from '../../../typography';

const TYPES = ['offered-automatic', 'offered-manual'];

const TableSellType = ({ value, onChange }) => {
  return (
    <TableSellTypeSC>
      <SmallText className="selector-text">
        <FormattedMessage
          id="investor_offers_filter_title"
          defaultMessage={dlt['investor_offers_filter_title']}
        />
      </SmallText>
      <div className="tab-wrapper">
        {TYPES.map((type) => (
          <button
            key={type}
            className={type === value ? 'active' : ''}
            onClick={() => onChange(type)}
          >
            <FormattedMessage
              id={`investor_offers_filter_${type}`}
              defaultMessage={dlt[`investor_offers_filter_${type}`]}
            />
          </button>
        ))}
      </div>
    </TableSellTypeSC>
  );
};

TableSellType.propTypes = {
  value: PropTypes.oneOf(TYPES).isRequired,
  onChange: PropTypes.func,
};

export default TableSellType;
